import { KEYS } from 'game/constants/SceneConstants';
import { SceneBase } from '@jollywise/jollygoodgame';
import { FONT_BASE } from 'game/constants/AppFonts';
import { OUTRO_STATES, OUTRO_STATE_VALUES } from 'game/constants/Constants';
import { trackGameEnd } from 'game/utils/GaTracking';

export class Outro extends SceneBase {
  constructor() {
    super({ key: KEYS.Outro, active: false });
  }
  create() {
    super.create();
    this.setBackgroundColour(0xc9e3e8);
    this.bg = this.add.image(0, 0, 'backgrounds', 'background_scenario').setOrigin(0);

    // determine the state of this outro
    // has player succeeded or failed?
    this.playerStatus = this.game._scores.scoreHasReachedZero()
      ? OUTRO_STATES.FAIL
      : OUTRO_STATES.SUCCESS;

    this.game.hud.setState('GAME_OUTRO');

    this.currentSpeechBubble = 1;

    this.addPlaceholderUI();

    // TODO: change this
    // small hack to stop the continue button from being pressed too early from prev scene
    setTimeout(() => {
      this.game.hud.events.on('CONTINUE_OUTRO', this.showNextPanel, this);
    }, 1000);

    trackGameEnd({
      play_count: this.game._player.timesPlayedGame,
      status: this.playerStatus?.toLowerCase(),
      start: this.game._player.getSessionStartTime,
    });
  }

  showNextPanel() {
    if (this.currentSpeechBubble < 2) {
      this.currentSpeechBubble++;
      this.introImage.setTexture(
        'ui',
        OUTRO_STATE_VALUES[this.playerStatus].panels[`panel_${this.currentSpeechBubble}`]
      );

      return;
    }

    this.endOutro();
  }

  endOutro() {
    this.game.sceneController.switchScene(KEYS.Result);
  }

  addPlaceholderUI() {
    this.introImage = this.add
      .sprite(
        840,
        this.game.defaultHeight,
        'ui',
        OUTRO_STATE_VALUES[this.playerStatus].panels[`panel_${this.currentSpeechBubble}`]
      )
      .setOrigin(0.5, 1);

    const timeData = this.game._player.currentTime;

    this.time = this.add
      .text(840, 160, timeData.time, {
        fontFamily: FONT_BASE.CALIBRE_BOLD,
        fontSize: '128px',
        color: '#a61780',
      })
      .setOrigin(0.5, 0);

    this.timePrefix = this.add
      .text(840, this.time.y + this.time.height / 2 + 40, timeData.prefix.toUpperCase(), {
        fontFamily: FONT_BASE.CALIBRE_REGULAR,
        fontSize: '88px',
        color: '#a61780',
      })
      .setOrigin(0.5, 0);

    this.add
      .image(0, 0, 'backgrounds', OUTRO_STATE_VALUES[this.playerStatus].header_image)
      .setOrigin(0);

    this.add
      .text(840, 60, OUTRO_STATE_VALUES[this.playerStatus].title, {
        fontFamily: FONT_BASE.CALIBRE_BOLD,
        fontSize: '68px',
        color: '#ffffff',
      })
      .setOrigin(0.5);
  }

  shutdown() {
    this.game.hud.events.off('CONTINUE_OUTRO', this.showNextPanel, this);
  }
}
